const tabNodes = document.querySelectorAll( '.realpress-tab-section li' );
const contentNodes = document.querySelectorAll( '.realpress-tab-content-section .realpress-field-content' );

const realpressTabSection = () => {
	//Section tabs
	const queryString = window.location.search;
	const urlParams = new URLSearchParams( queryString );
	const propertyId = urlParams.get( 'post' );
	let activeTabId = '';
	let data = localStorage.getItem( 'realpress_property_edit_tab_id' );

	hideAllFieldContent();
	if ( data == null ) {
		data = {};
		//Set first li is active
		tabNodes[ 0 ].classList.add( 'active' );
		contentNodes[ 0 ].style.display = 'block';
	} else {
		data = JSON.parse( data );
		if ( !! propertyId && data[ propertyId ] ) {
			activeTabId = data[ propertyId ];
		}
	}

	if ( activeTabId ) {
		document.querySelector( `#${ activeTabId }` ).classList.add( 'active' );
		const activeCcontentId = activeTabId.replace( 'tab', 'content' );
		document.querySelector( `#${ activeCcontentId }` ).style.display = 'block';
	} else {
		tabNodes[ 0 ].classList.add( 'active' );
		contentNodes[ 0 ].style.display = 'block';
	}

	for ( let i = 0; i < tabNodes.length; i++ ) {
		tabNodes[ i ].addEventListener( 'click', function( event ) {
			event.preventDefault();
			const selectedNode = this;
			for ( let j = 0; j < tabNodes.length; j++ ) {
				if ( tabNodes[ j ] === selectedNode ) {
					tabNodes[ j ].classList.add( 'active' );
				} else {
					tabNodes[ j ].classList.remove( 'active' );
				}
			}
			hideAllFieldContent();
			const activeTabId = selectedNode.getAttribute( 'id' );
			const activeContentId = activeTabId.replace( 'tab', 'content' );
			document.querySelector( `#${ activeContentId }` ).style.display = 'block';
			if ( !! propertyId ) {
				data[ propertyId ] = activeTabId;
			}

			localStorage.setItem( 'realpress_property_edit_tab_id', JSON.stringify( data ) );
		} );
	}
};

const hideAllFieldContent = () => {
	for ( let i = 0; i < contentNodes.length; i++ ) {
		contentNodes[ i ].style.display = 'none';
	}
};

export default realpressTabSection;
